(function () {
    'use strict';

    angular.module("imApp").factory("accountingAllocationLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3775,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3776,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
